module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('p', [_vm._v("Please Note: Only .csv (comma seperated values) files are allowed for upload.")]), _vm._v(" "), _c('p', [_vm._v("The format and order of the import file must be as follows:")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Company Type (Customer/Specifier)*, Customer Code*, Registration No., VAT No., Name*, Trading Name, Address Line 1*, Address LIne 2, Postal Code, Contact No.*, Fax No., Email, Region Name*.")])]), _vm._v(" "), _c('p', [_vm._v("Or download the import template "), _c('a', {
    attrs: {
      "href": "http://myorder.ndtec.co.za/docs/myorder_company_import_template_new.csv",
      "download": ""
    }
  }, [_vm._v("here")])]), _vm._v(" "), _c('p', [_vm._v("The first row must be the column headers. Please confirm field validity and cardinality to ensure import integrity.")]), _vm._v(" "), _c('div', {
    staticClass: "fileHolder"
  }, [_c('input', {
    staticClass: "fileUpload",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fncCheckCsv
    }
  }), _vm._v(" "), _c('p', [_vm._v("Drag & Drop / Click to Add Files")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.fileName))])])]), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.uploadValue
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncImportCompanies()
      }
    }
  }, [_vm._v("Import")]) : _vm._e()], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "requiredMessage",
    attrs: {
      "lg12": ""
    }
  }, [_c('small', [_c('strong', [_vm._v("* The button will activate once all required fields have been completed.")])])])], 1)], 1)
},staticRenderFns: []}